import { all } from "redux-saga/effects";
import dashboardSaga from "./dashboardSaga";
import authSaga from "./authSaga";
import userSaga from "./userSaga";
import subAdminSaga from "./subAdminSaga";
import astromallSaga from "./astromallSaga";
import astropujaSaga from "./astropujaSaga";
import historySaga from "./historySaga";
import skillSaga from "./skillSaga";
import remediesSaga from "./remediesSaga";
import expertiseSaga from "./expertiseSaga";
import languageSaga from "./languageSaga";
import bannerSaga from "./bannerSaga";
import categorySaga from "./categorySaga";
import subCategorySaga from "./subCategorySaga";
import yatraSaga from "./yatraSaga";
import sancharSaga from "./sancharSaga";
import religiousSaga from "./religiousSaga";
import ecommerceSaga from "./ecommerceSaga";
import testimonialsSaga from "./testimonialsSaga";
import staticPageSaga from "./staticPageSaga";
import transactionSaga from "./transactionSaga";
import operatorImageSaga from "./operatorImageSaga";
import flightImageSaga from "./flightImageSaga";
import astrologerSaga from "./astrologerSaga";
import roleSaga from "./roleSaga";
import issueSaga from "./issueSaga";

export default function* rootSaga() {
  yield all([
    dashboardSaga(),
    authSaga(),
    userSaga(),
    subAdminSaga(),
    astromallSaga(),
    astropujaSaga(),
    historySaga(),
    skillSaga(),
    remediesSaga(),
    expertiseSaga(),
    languageSaga(),
    bannerSaga(),
    categorySaga(),
    subCategorySaga(),
    yatraSaga(),
    sancharSaga(),
    religiousSaga(),
    ecommerceSaga(),
    testimonialsSaga(),
    staticPageSaga(),
    transactionSaga(),
    operatorImageSaga(),
    flightImageSaga(),
    astrologerSaga(),
    roleSaga(),
    issueSaga(),
  ]);
};
